export const API_ENDPOINT_NEST = `${process.env.NEXT_PUBLIC_NEST_API_ENDPOINT}`;

export const API_PAYMENT_ENDPOINT =
  process.env.NEXT_PUBLIC_API_PAYMENT_ENDPOINT;

export const API_ENV = process.env.NEXT_PUBLIC_ENVIRONMENT;

export const FB_APP_ID = process.env.NEXT_PUBLIC_FB_APP_ID;
export const APP_REDIRECT_URI = process.env.NEXT_PUBLIC_REDIRECT_URI;
export const TWITCH_CLIENT_ID = process.env.NEXT_PUBLIC_TWITCH_CLIENT_ID;
export const TWITCH_REDIRECT_URI = process.env.NEXT_PUBLIC_TWITCH_REDIRECT_URI;

export const SCOPELY_LOGIN_ENDPOINT =
  process.env.NEXT_PUBLIC_SCOPELY_LOGIN_ENDPOINT;
export const SCOPELY_LOGIN_CLIENT_ID =
  process.env.NEXT_PUBLIC_SCOPELY_LOGIN_CLIENT_ID;

// Scopely Account authorization server. Was hardcoded to aprod for every
// environment; env-driven so non-prod can be retargeted the moment Scopely
// gives us a non-prod host. Until then every environment resolves to aprod,
// which is what shipped before.
export const SCOPELY_AUTH_SERVER =
  process.env.NEXT_PUBLIC_SCOPELY_AUTH_SERVER ||
  'https://heimdall.aprod.scopely.io';

// Where Scopely returns the browser after logout.
//
// On the 2.0 leg this value is sent verbatim as `post_logout_redirect_uri` and
// must be on the client's registered post-logout allowlist — a separate list
// from the login `redirect_uris`. An unregistered value does not come back with
// an error: account.scopely.com refuses to redirect at all and answers 400 with
// its own error page, so the user is stranded off-origin with no toast, no
// console and no RUM. `/scopelyid/logout-callback` is registered, so every env
// file now sets this explicitly.
//
// The fallback to the login callback is kept only for builds where the variable
// is unset (local, ad-hoc). It still works on the 1.0 leg, which never leaves
// our origin — it just navigates to `logoutRedirectUri?state=…`.
export const SCOPELY_LOGOUT_REDIRECT_URI =
  process.env.NEXT_PUBLIC_SCOPELY_LOGOUT_REDIRECT_URI ||
  process.env.NEXT_PUBLIC_REDIRECT_URI;

// Titan tenant used while nobody is logged in.
//
// Playgami's `scopely_account_v2_enabled` audience matches on the tenant that
// `bootstrapScopelyIdentity` sends as `?userId=`, but the OAuth2 version is
// resolved on the login click — when the tenant is still '' and the SDK drops
// the parameter entirely, leaving the request unattributable. Seeding a stable
// placeholder makes the portal addressable by that audience at all.
//
// Env-overridable so a single tester can be targeted instead (set it to their
// Scopely account id) without a rebuild. The value has to match what Playgami
// configured on their side exactly.
export const SCOPELY_GUEST_TENANT =
  process.env.NEXT_PUBLIC_SCOPELY_GUEST_TENANT || 'guest';

export const IFRAME_PLAY_URL = process.env.NEXT_PUBLIC_IFRAME_URL;

export const TITAN_API_KEY = process.env.NEXT_PUBLIC_TITAN_API_KEY;
export const TITAN_EVENT_SOURCE = process.env.NEXT_PUBLIC_TITAN_EVENT_SOURCE;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

export const CLIENT_ID = process.env.NEXT_PUBLIC_TWITCH_CLIENT_ID;

export const S3_IMAGES_URL = `https://static.wwechampions.com`;
export const S3_USERS_IMAGE = `${S3_IMAGES_URL}/user_images`;

export const APP_OPEN = 'app_open';
export const APP_INSTALL = 'app_install';
export const CURRENT_USER_FOLLOW_EVENT = 'following_events';

export const NOT_IN_FACTIONS = 'not in a faction';

export const MAILCHIMP_URL = `https://wwechampions.us3.list-manage.com/subscribe/post?u=a3bd3e264e0857b6ed1249ae4&amp;id=7fa786a0b3`;
export const SCOPELY_PRIVACY_POLICY = `https://scopely.com/privacy/`;
export const SCOPELY_TERMS = `https://scopely.com/tos/`;
export const GOOGLE_PLAY_URL = 'https://app.adjust.com/xeihp19';
export const APP_STORE_URL = 'https://app.adjust.com/ou4py9h';
export const BACK_TO_GAME_IOS_URL = `https://flkk.adj.st?adj_t=ou4py9h`;
export const BACK_TO_GAME_ANDROID_URL = `https://app.adjust.com/xeihp19?deep_link=whiplash%3A%2F%2F`;

export const EVENT_RBE = {
  START: 'start',
  PROGRESS: 'objective_progress',
  SOLO: 'Solo',
  GLOBAL: 'Global',
  SOLO_TYPE: 2,
  GLOBAL_TYPE: 1,
  FIRST_COUNT: 1,
};

export const SHORT_CACHE_TIME = 1000 * 30;
export const MEDIUM_CACHE_TIME = 1000 * 300;
export const LONG_CACHE_TIME = 3600 * 1000;
export const MAX_REFETCH_INTERVAL = 24 * 3600 * 1000;
export const MIN_REFETCH_INTERVAL = 1000 * 10;

export const ANALYTICS_RATE_LIMIT_MS = 300;
export const ANALYTICS_VIEWED_LIMIT_MS = 1000;
